let Chroma = require('chroma-js')
let _ = require('lodash')

function buildStructure (obj) {
  //first build the tree
  let buildNode = (node, key, level) => {
    let v = {
      key: key,
      title: key, 
      level: level,
      selected: false,
      expanded: true,
      active: false,
      hasChildren: false,
      isLeaf: false,
      parent: null,
      code: null,
      tags: []
    }
    if (_.isString(node)) {
      v.title = node //shorthand
    } else {
      v = _.merge(v, _.omit(node, ['children']))
    }
    if (node.children) {
      v.children = []
      _.each(_.keys(node.children), (k, index) => {
        let child = buildNode(node.children[k], k, level + 1)
        child.parent = v
        child.lessonIndex = index + 1 // 1-based index among siblings, for "Les X" display
        v.children.push(child)
      })
      v.hasChildren = v.children.length > 0
    }
    return v
  }

  let extractRows = (node) => {
    let rows = []
    rows.push(node)
    if (node.hasChildren) {
      _.each(node.children, (c) => {
        _.each(extractRows(c), (r) => rows.push(r))
      })
    }
    return rows
  }

  let tree = buildNode(obj, null, 0)
  let result = {
    tree: tree,
    rows: extractRows(tree)
  }


  //now let's calculate the width and offset of each cell
  
  //compute widths of each cell
  let computeWidth = (node) => {
    if (node.hasChildren && !node.isLeaf) {
      node.width = _.sumBy(node.children, computeWidth)
    } else {
      node.width = 1
    }
    return node.width
  }
  computeWidth(result.tree)
  let totalWidth = result.tree.width

  //now offsets and index
  let maxLevel = 0
  let computeOffset = (node, baseOffset) => {
    node.offset = baseOffset
    node.totalWidth = totalWidth
    maxLevel = Math.max(maxLevel, node.level)
    if (node.hasChildren) {
      let current = baseOffset
      _.each(node.children, (c, index) => {
        computeOffset(c, current)
        current += c.width //for next
        c.index = index
        c.maxIndex = node.children.length - 1
      })
    }
  }
  computeOffset(result.tree, 0)
 
  //colors
  let scale = Chroma.scale(obj.colorScale || 'Spectral').padding(0.15)
  let buildColors = (node, parent) => {
    node.maxLevel = maxLevel 
    if (!node.color) {
      node.color = scale(1.0 * (node.offset + node.width / 2.0) / node.totalWidth)
    }
    _.each(node.children, (c) => buildColors(c, node))
  }
  buildColors(result.tree)

  return result
}

export {buildStructure}
